type BrowseSelectionRow = {
  id: string;
  name: string;
  status?: string;
};

/** Single browse replaces the selection. Multi browse adds the matched row to the rows already selected. */
export const browseIdsAfterAutoSelect = (
  previousRows: Array<{ id?: string; status?: string }>,
  nextId: string,
  isSingleSelect: boolean
): string[] => {
  if (isSingleSelect) {
    return [nextId];
  }

  const previousIds = previousRows.filter((row) => row.id && row.status !== 'remove').map((row) => String(row.id));

  return [...new Set([...previousIds, nextId])];
};

/** Keep rows selected on other pages when the table only reports the current page. */
export const mergeBrowsePageSelection = <T extends BrowseSelectionRow>(selectedIds: string[], currentPageRows: T[], previousRows: T[]): T[] => {
  const byId = new Map<string, T>();

  for (const row of previousRows) {
    if (row.id && row.status !== 'remove') {
      byId.set(String(row.id), row);
    }
  }

  for (const row of currentPageRows) {
    if (row.id) {
      byId.set(String(row.id), row);
    }
  }

  return selectedIds.map((id) => byId.get(String(id)) ?? ({ id: String(id), name: '' } as T));
};
